import React from "react";
import { FaCheckCircle, FaSpinner, FaExclamationCircle, FaEdit, FaBan, FaExclamationTriangle } from "react-icons/fa";
import { renderCardIcon, fineTunedModelIcon } from "../common/IconLibrary";

const StatusBadge = ({ status }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'succeeded':
        return 'bg-green-500/50';
      case 'pending':
      case 'running':
        return 'bg-orange-500';
      case 'failed':
        return 'bg-red-500';
      case 'cancelled':
        return 'bg-yellow-500';
      case 'draft':
        return 'bg-gray-500';
      default:
        return 'bg-gray-500';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'succeeded':
        return <FaCheckCircle className="mr-1" />;
      case 'pending':
      case 'running':
        return <FaSpinner className="mr-1 animate-spin" />;
      case 'failed':
        return <FaExclamationCircle className="mr-1" />;
      case 'cancelled':
        return <FaBan className="mr-1" />;
      case 'draft':
        return <FaEdit className="mr-1" />;
      default:
        return <FaExclamationTriangle className="mr-1" />;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'succeeded':
        return 'Processed';
      case 'pending':
        return 'Pending';
      case 'running':
        return 'Processing';
      case 'cancelled':
        return 'Cancelled';
      case 'draft':
        return 'Draft';
      case 'failed':
        return 'Failed';
      default:
        return status;
    }
  };

  return (
    <span className={`flex items-center px-2 py-1 rounded-full text-xs text-white ${getStatusColor(status)}`}>
      {getStatusIcon(status)}
      <span className="capitalize">{getStatusText(status)}</span>
    </span>
  );
};

const FineTunedModelCard = ({ item, onClick }) => {
  return (
    <div className="card-glass cursor-pointer flex flex-col h-full" onClick={() => onClick(item)}>
      <div className="flex items-center mb-2">
        <span className="text-gray-300 mr-2">
          {renderCardIcon(fineTunedModelIcon, 24)}
        </span>
        <h3 className="text-xl font-semibold text-gray-100">{item.name}</h3>
      </div>
      <div className="text-gray-300 mb-2 flex-grow">
        <p className="text-sm line-clamp-3 min-h-[3em]">{item.description || "No description provided"}</p>
      </div>
      <div className="flex items-center mb-2">
        <span className="text-gray-400 text-sm">Base Model: {item.base_model || "N/A"}</span>
      </div>
      <div className="flex flex-wrap mt-2 mb-4">
        {item.tags && item.tags.length > 0 ? item.tags.map((tag, index) => (
          <span
            key={index}
            className="bg-blue-500 text-white text-xs px-2 py-1 rounded-full mr-2 mb-2"
          >
            {tag}
          </span>
        )) : <span className="text-gray-400 text-sm">No tags</span>}
      </div>
      <div className="flex justify-between items-end mt-2">
        <StatusBadge status={item.status} />
      </div>
    </div>
  );
};

export default FineTunedModelCard;